export interface DebtRegistryDebtEntry {
  id: string;
  ssn: string;
  batchID: number | null;
  type: DebtRegistryEntryType;
  receivedTime: string;
  processedTime: string;
  financialInstitutionID: string;
  financialInstitutionName: string;
  creditLimit: number | null;
  interestBearingBalance: number | null;
  nonInterestBearingBalance: number | null;
  nominalInterestRate: number | null;
  installmentChargePeriod: string | null;
  installmentCharges: number | null;
  originalBalance: number | null;
  balance: number | null;
  terms: string | null;
  coBorrower: string | null;
  owner: string | null;
  createdAt: string | null;
  loanApplicationID: string;
  outstandingAmount?: number | null;
  creditor?: string | null;
  refinanceable?: boolean;
}

export enum DebtRegistryEntryType {
  ChargeCard = 'chargeCard',
  RepaymentLoan = 'repaymentLoan',
  CreditFacility = 'creditFacility',
}

export interface DebtRegistryConsent {
  ssn?: string;
  personId: string;
  createdAt?: string;
  expiresAt?: string;
}

export interface DebtRegistryDebts {
  debts: DebtRegistryDebtEntry[];
}

export interface DebtRegistryData {
  debts: DebtRegistryDebtEntry[];
  debtTotal: number;
  savings: number;
}

export interface DebtRegistryPatchConsentData {
  timestamp: string;
  uuid: string;
  errorCode: string;
  errorMessage: string;
  hasConsent: boolean;
}
